module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 016.aed85996.jpg";